import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from '../components/Table';
import { GlobalContext } from '../context/GlobalContext';
import { unsafeAPI } from '../hooks/api';

export default function VentasOnline() {
	const { userData } = useContext(GlobalContext);
	const navigate = useNavigate();
	const [key, setKey] = useState(Math.random());

	if (!userData?.email) return null;

	return (
		<div className="h-full w-full p-4 md:p-6">
			<Table
				key={key}
				userEmail={userData.master_store.id}
				endpoint="https://api.krece.app/tables/pre_registered_devices/"
				pagination={{ default: 100, batchSizes: [100] }}
				orderBy={{ columnName: 'Fecha de Compra', columnOrder: 'DESC' }}
				filters={[
					{
						column: 'Sucursal',
						options: [
							{ label: 'Todas las sucursales', value: 'Todas las sucursales' },
							...[...(userData?.sub_stores || [])].map((e) => ({ label: e, value: e }))
						],
						defaultValue: 'Todas las sucursales'
					}
				]}
				search_by={{ column: 'Cedula', placeholder: 'Buscar Cedula...', type: 'numeric' }}
				actionButton={{
					label: 'Completar registro',
					onClick: (row) => {
						if (!row?.['ID']) {
							alert('No se encontró la columna "ID" con el ID de la venta');
						}

						navigate('/newsale', {
							state: { pre_registered_device_id: row?.['ID'] }
						});
					}
				}}
				deleteButton={{
					onClick: async (row) => {
						try {
							if (!row?.['ID']) {
								alert('No se encontró la columna "ID" con el ID de la venta');
								return true;
							}

							const response = await unsafeAPI(
								'DELETE',
								`https://api.krece.app/registration/preregistereddevices/?id=${row?.['ID']}`,
								null,
								userData,
								userData?.country || ''
							);
							if (response.success) {
								setKey(Math.random());
							}
						} catch (_) {
						} finally {
							return true;
						}
					}
				}}
			/>
		</div>
	);
}
